import { render, staticRenderFns } from "./PriceMonitorScreen.vue?vue&type=template&id=18611f33"
import script from "./PriceMonitorScreen.vue?vue&type=script&lang=ts"
export * from "./PriceMonitorScreen.vue?vue&type=script&lang=ts"
import style0 from "./PriceMonitorScreen.vue?vue&type=style&index=0&id=18611f33&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QPagination,QDialog});
